import { ListingType } from "./listingTypes";

export const listingReducer = {
  resetError: (state: ListingType) => {
    state.error = null;
  },
  resetSuccess: (state: ListingType) => {
    state.success = null;
  },
  resetListingFetching: (state: ListingType) => {
    state.fetching = false;
  },
  resetJobTrackerListing: (state: ListingType) => {
    state.jobTrackerListing = [];
  },
  resetOpenJobsList: (state: ListingType) => {
    state.openJobsListing = [];
  },
  resetJobProgressCommentsSuccess: (state: ListingType) => {
    state.jobProgressCommentsSuccess = null;
  },
  resetJobProgressCommentsListing: (state: ListingType) => {
    state.jobProgressCommentsList = [];
  },
  resetDocumentsLinkList: (state: ListingType) => {
    state.documentsLinkList = [];
  },
  resetAssginedClientsOpenJobsList: (state: ListingType) => {
    state.assignedClientsOpenJobsList = [];
  },
  resetAllOpenItemsLst: (state: ListingType) => {
    state.allOpenItemsList = [];
  },
  resetFileFolderCountData: (state: ListingType) => {
    state.fileFolderCount = [];
  },
  resetInvoiveCountData: (state: ListingType) => {
    state.invoiceCount = [];
  },
  resetAllOpenItemsListTotelCount: (state: ListingType) => {
    state.openJobsListingTotalCount = "";
  },
  resetDailyActiveUserList: (state: ListingType) => {
    state.dailyActiveUserList = [];
  },
  resetUserSessionLoginCountList: (state: ListingType) => {
    state.userSessionLoginCountList = [];
  },
  resetMonthlyActiveUserList: (state: ListingType) => {
    state.monthlyActiveUserList = [];
  },
  resetUserReportList: (state: ListingType) => {
    state.userReportList = [];
  },
  resetUserWiseInvoiceCountReportList: (state: ListingType) => {
    state.userWiseInvoiceCountReportList = [];
  },
  resetAllEwayBillEInvoiceList: (state: ListingType) => {
    state.allEwayBillEInvoiceList = [];
  },
  resetAllClientLockDateList: (state: ListingType) => {
    state.allClientLockDateList = [];
  },
  resetAllClientLockDateTotalCount: (state: ListingType) => {
    state.allClientLockDateTotalCount = 0;
  },
  resetAllExternalUserEmailerList: (state: ListingType) => {
    state.allExternalUserEmailerList = [];
  },
  resetAllExternalUserEmailerTotalCount: (state: ListingType) => {
    state.allExternalUserEmailerTotalCount = 0;
  },
  resetInvoiceMonthlyGraphData: (state: ListingType) => {
    state.invoiceCountGraphData = [];
  },
  resetAlluserApprovedEntryList: (state: ListingType) => {
    state.allUserApprovedEntryList = [];
  },
  resetAlluserApprovedEntryTotalCount: (state: ListingType) => {
    state.allUserApprovedEntryTotalCount = 0;
  },

  resetAllClientBulkUploadList: (state: ListingType) => {
    state.allClientBulkUploadList = [];
  },
  resetAllClientBulkUploadTotalCount: (state: ListingType) => {
    state.allClientBulkUploadTotalCount = 0;
  },
  resetUserWiseOCRReportList: (state: ListingType) => {
    state.userWiseOCRReportList = [];
  },
  resetClientWiseOCRReportList: (state: ListingType) => {
    state.clientWiseOCRReportList = [];
  }
};
